import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const Check = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 24 24"
      width={computedSize}
      height={computedSize}
      {...props}
    >
      <path
        fill="#FF6A00"
        d="m9.385 15.194-2.86-2.863a.806.806 0 0 0-1.32.262.81.81 0 0 0 .177.883l3.423 3.427a.813.813 0 0 0 1.152 0l8.66-8.662a.804.804 0 0 0 0-1.145.804.804 0 0 0-1.143 0z"
      />
    </svg>
  );
};
export default Check;
